var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#DD2736"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1079:9102)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3751 7.02498C6.21846 7.02498 6.0876 7.15584 6.0876 7.31248V12.9375C6.0876 13.0941 6.21846 13.225 6.3751 13.225H13.8751C14.0317 13.225 14.1626 13.0941 14.1626 12.9375V7.31248C14.1626 7.15584 14.0317 7.02498 13.8751 7.02498H6.3751ZM4.7876 7.31248C4.7876 6.43787 5.50049 5.72498 6.3751 5.72498H13.8751C14.7497 5.72498 15.4626 6.43787 15.4626 7.31248V12.9375C15.4626 13.8121 14.7497 14.525 13.8751 14.525H6.3751C5.50049 14.525 4.7876 13.8121 4.7876 12.9375V7.31248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.90515 6.93972C5.11102 6.64563 5.51631 6.57411 5.8104 6.77997L10.1252 9.80029L14.4399 6.77997C14.734 6.57411 15.1393 6.64563 15.3452 6.93972C15.551 7.23381 15.4795 7.63911 15.1854 7.84497L10.4979 11.1262C10.2741 11.2829 9.97621 11.2829 9.7524 11.1262L5.0649 7.84497C4.77081 7.63911 4.69929 7.23381 4.90515 6.93972Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1079:9102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.25,
    height: 11.25,
    fill: "white",
    transform: "translate(4.5 4.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.c9d351c7ea5e0cca864e5730e5996842.svg";
export { ForwardRef as ReactComponent };